export default [
  //    - BookingPolicies list
  {
    path: "/booking-policies",
    name: "foravila-booking-policies-list",
    component: () =>
      import("@/views/booking-policies/list/BookingPoliciesList.vue"),
    meta: {
      action: "manage",
      resource: "all",
      pageTitle: "Llistat de polítiques de reserva",
      breadcrumb: [{ text: "Polítiques" }, { text: "Llistat", active: true }],
    },
  },
];
